import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { AnalyticsService } from '../analytics/analytics.service';
import { AngularEnvironment } from '../env';
import { UtilityService } from '../util';
import { InternalAuthError, InternalAuthState } from './internal-auth-state';


/**
 * Return a function suitable for Firebase's onAuthStateChanged()
 */
export function getInternalAuthStateChangedHandler(
	auth: firebase.auth.Auth,
	analytics: AnalyticsService,
	util: UtilityService,
	router: Router,
	setState: (state: InternalAuthState) => void,
	env: AngularEnvironment,
) {


	return async (user: firebase.User | null) => {

		util.log.info('onAuthStateChanged', { extra: user, extraLogging: 'ExtraToConsole' })


		//
		// Clear out any data stored on the router
		//
		router.resetConfig(router.config);

		if (!user) {

			// //
			// // Go back to the home page.
			// //
			// if (router.url !== '/') {
			// 	setTimeout(() => { router.navigate(['/'], { replaceUrl: true }) });
			// }


			//
			// We are now signed out.
			//
			setState({ status: 'signed-out' });

		}
		else {

			const redirect = await firebase.auth().getRedirectResult();
			const fromPersistence = redirect?.user == undefined;

			const isInternalAuth = user.providerData
				.filter(userInfo => userInfo?.providerId == 'oidc.eforall-workspace')
				.length > 0;

			console.log(`isInternalAuth: ` + isInternalAuth);

			const email = user.email;

			if (!email) {
				await auth.signOut();
				setState({ status: 'error', error: InternalAuthError.EmailNotVerified });
				throw new Error(`No Email Address`);	// TODO: communicate through ErrorService
			}
			else if (!user.emailVerified) {
				await auth.signOut();
				setState({ status: 'error', error: InternalAuthError.EmailNotVerified });
				throw new Error(`${email} Not Verified!`); // TODO: communicate through ErrorService
			}
			else if (isInternalAuth && !email.endsWith('@eforall.org') && !email.endsWith('@bacancy.com')) {
				console.error(`ERROR: Internal Auth may only be used with @eforall.org accounts.  ${email} is rejected.  Automatically signing out.`);
				await auth.signOut();
				setState({ status: 'signed-out' });
			}
			else {

				analytics.logLogin({ email, provider: user.providerId })

				setState({
					status: 'signed-in',
					user,
					loginType: fromPersistence ? 'from-persistence' : 'new',
				});
			}
		}
	}

}